/**
 * BootyLift PDP behaviour that is not tied to one block.
 *
 * 1. SAVE badge beside the price. Their live store shows "SAVE 65%" next to
 *    $19.99 / $57.99. The figure is derived from the rendered prices, never
 *    hardcoded, and it FLOORS - 1 - 19.99/57.99 is 65.5% and the store shows 65.
 *    Rounding would print 66 and read as an error on their own page.
 *    It recomputes on variant change, because price and compare-at differ by
 *    length and size (the Tall/Plus variants are $28.00 against $82.00).
 *
 * 2. Keeps the bundle's first unit row in step with the main variant pickers,
 *    so a shopper who has already chosen a colour and size above does not have
 *    to choose the same thing again for item 1.
 */

const money = (el) => {
  if (!el) return null;
  const n = parseFloat(el.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
};

function renderSaveBadge() {
  // Horizon's price block is two sibling spans inside an unclassed wrapper, each
  // carrying a visually-hidden label ("Regular price", "Sale price"). Reading
  // `.price` alone gets only the sale figure - the same screen-reader markup
  // that made the price block look inverted during the audit.
  const wasEl = document.querySelector('.compare-at-price');
  const nowEl = document.querySelector('.price-item__group.price');
  if (!wasEl || !nowEl) return;
  const host = nowEl.parentElement;
  const existing = host.querySelector('.bl-save-badge');
  if (existing) existing.remove();
  const now = money(nowEl);
  const was = money(wasEl);
  if (!now || !was || was <= now) return;
  const pct = Math.floor((1 - now / was) * 100);
  if (pct < 1) return;
  const b = document.createElement('span');
  b.className = 'bl-save-badge';
  b.textContent = `SAVE ${pct}%`;
  host.appendChild(b);
}

let mirroring = false;

/**
 * Mirrors the bundle's first unit into the standalone variant picker.
 *
 * The picker is hidden - the shopper chooses inside the bundle - but Horizon's
 * gallery, price and availability all hang off it, so it has to stay in the DOM
 * and stay in step. Clicking its radio is what makes the main image follow the
 * colour, so this drives the page rather than just recording a value.
 */
function mirrorFirstUnitToPicker() {
  if (mirroring) return;
  const bundle = document.querySelector('bl-bundle-tiers');
  if (!bundle) return;
  const selected = bundle.querySelector('input[type="radio"][name^="bl-bundle-"]:checked');
  const tier = selected?.closest('.bl-bundle__tier');
  const unit = tier?.querySelector('.bl-bundle__unit');
  if (!unit) return;

  const names = [...document.querySelectorAll('.variant-option')].map((f) => {
    const i = f.querySelector('input[data-option-name]');
    return i ? i.dataset.optionName : null;
  });
  const values = window.BLBundleValues ? window.BLBundleValues(unit) : null;
  if (!values) return;

  mirroring = true;
  values.forEach((val, idx) => {
    const name = names[idx];
    if (!name) return;
    const target = document.querySelector(
      `.variant-option input[data-option-name="${CSS.escape(name)}"][value="${CSS.escape(val)}"]`
    );
    if (target && !target.checked) target.click();
  });
  setTimeout(() => {
    mirroring = false;
  }, 400);
}

function update() {
  renderSaveBadge();
  if (document.querySelector('bl-bundle-tiers')) {
    document.body.classList.add('bl-hide-variant-picker');
  }
}

document.addEventListener('change', (e) => {
  if (e.target.closest('.bl-bundle__unit')) setTimeout(mirrorFirstUnitToPicker, 30);
});

document.addEventListener('DOMContentLoaded', update);
update();

// Horizon re-renders the price block on variant change rather than mutating it,
// so a change listener alone misses it - observe the container too.
document.addEventListener('change', (e) => {
  if (e.target.closest('.variant-option')) setTimeout(update, 60);
});

const host = document.querySelector('variant-picker')?.closest('.shopify-section');
if (host) {
  new MutationObserver(() => {
    clearTimeout(window.__blPdpTimer);
    window.__blPdpTimer = setTimeout(update, 40);
  }).observe(host, { childList: true, subtree: true });
}
